// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"c69663b2","968":"dafbba46"}[chunkId] + ".chunk.js";
};